import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  welcome: 'welcome',
  jsonForm: 'jsonForm',
  saveButton: '-save-button',
  submitButton: '-submit-button',
  nextBtn: 'next-button',
  prevBtn: 'prev-button',
  finished: 'finished',
};

export default prefixObjectValues(modal, 'peer-reference-form');
